import type { FormatCapabilities } from '../types';

export const ZPL_DISPLAY_FONT = "Arial, 'Helvetica Neue', Helvetica, sans-serif";

export const zplCapabilities: FormatCapabilities = {
  supportsColor: false,
  supportsOpacity: false,
  supportsCustomFonts: false,
  supportsSvgShapes: false,
  supportsLetterSpacing: false,
  supportsReelSplitting: false,
  supportsPageLayout: false,
  supportsShapeFill: false,
  supportsBackgroundColor: false,

  fixedBackground: '#ffffff',
  fixedTextColor: '#000000',
  displayFont: ZPL_DISPLAY_FONT,
  colorLabel: 'Fixed: Black',
  imageNote: 'Image will be converted to 1-bit monochrome for output.',
};
